import { Swiper, SwiperSlide } from "swiper/react";
import { useEffect, useState, useRef } from "react";
import "swiper/css";
import { Autoplay } from "swiper/modules";
import "../../../assets/css/style.css";
import { HomeService } from "../../../services/home.service";
interface Partner {
    id: number;
    name: string;
    logo: string;
}

// const staticPartners: Partner[] = [
//     { id: 1, name: "Partner 1", logo: "	https://backend.bionet.az/storage/partners/8uqMkzX8JlD9ZSGPrdFvAELw30hcnGYh8VhXFjVy.png" },
//     { id: 2, name: "Partner 2", logo: "https://backend.bionet.az/storage/partners/vv00Rc0TkpAp3K7ST7HY3vXOy4QY5FZ8JQDNBUVr.png" },
//     { id: 3, name: "Partner 3", logo: "https://backend.bionet.az/storage/partners/yLBEbwSZPmbisBVEO43aAYvHqhEE9zVwOSMUjPtq.png" },
//     { id: 4, name: "Partner 4", logo: "	https://backend.bionet.az/storage/partners/fjYvWPXq4FKs6sYU4VoK6iFRU0SzqN89e1WcUNw4.png" },
//     { id: 5, name: "Partner 5", logo: "https://backend.bionet.az/storage/partners/y91mNEQYkf7CaFB46Sg5nv2lyIA785omABpi0AgR.png" },
//     { id: 6, name: "Partner 6", logo: "https://backend.bionet.az/storage/partners/nCGUq14j5KoW152msccZTwZMDPTfWTQoWDIGHRLH.png" },
//     { id: 7, name: "Partner 7", logo: "https://backend.bionet.az/storage/partners/vmohV4Tfthpk9hstjln0uYmUw2vSXSK97kNTdfPn.png" },
//     { id: 8, name: "Partner 8", logo: "https://backend.bionet.az/storage/partners/armdnvoHyBvamKDM2m50GtEevduYD9bkK16XPKRo.svg" },
//     { id: 9, name: "Partner 9", logo: "https://backend.bionet.az/storage/partners/guyBzI6dQTV0P8DDpI0WRJXdFrnS3CUZIayjS9At.svg" },
//     { id: 10, name: "Partner 10", logo: "https://backend.bionet.az/storage/partners/MF2B4yIIsMIaOiNrR7ORVWbcVnlsZr89fuLQBRcI.png" },
// ];

const HomeSLider = () => {
    const [activeIndexes, setActiveIndexes] = useState<number[]>([]);
    const [allPartners, setAllPartners] = useState<Partner[]>([]);
    const swiperRef = useRef<any>(null);
    const [staticPartners, setStaticPartners] = useState<Partner[]>([])

    useEffect(() => {
        HomeService.getHomeİntegration().then((res) => {
            console.log(res.data.data)
            setStaticPartners(res.data.data)
        })
    }, [])
    const handleSlideChange = (swiper: any) => {
        const slidesToShow = Math.floor(swiper.params.slidesPerView);

        let activeCount = 1;
        if (slidesToShow >= 6) activeCount = 4;
        else if (slidesToShow >= 4) activeCount = 2;
        else if (slidesToShow === 3) activeCount = 2;
        else activeCount = 1;

        const start = swiper.activeIndex + Math.floor((slidesToShow - activeCount) / 2);
        const newActiveIndexes: number[] = [];

        for (let i = 0; i < activeCount; i++) {
            const realIndex = swiper.slides[(start + i) % swiper.slides.length]?.dataset?.swiperSlideIndex;
            if (realIndex !== undefined) {
                newActiveIndexes.push(Number(realIndex));
            }
        }

        setActiveIndexes(newActiveIndexes);
    };



    useEffect(() => {
        const minSlidesForLoop = 7;
        const extendedPartners =
            staticPartners.length < minSlidesForLoop
                ? [...staticPartners, ...staticPartners].slice(0, minSlidesForLoop)
                : staticPartners;

        setAllPartners(extendedPartners);
        setActiveIndexes([1, 2, 3, 4]);
    }, [staticPartners]);

    return (
        <section id="services-section">
            <div className="services-section">
                <div className="container">
                    <div className="section-head">
                        <h1 className="title">İntegrasiyalarımız</h1>
                    </div>
                </div>
                <div className="services-slider">
                    <div className="container">
                        <Swiper
                            slidesPerView={6}
                            className="my-swiper"
                            onSlideChange={handleSlideChange}
                            onSwiper={(swiper: any) => {
                                swiperRef.current = swiper;
                                handleSlideChange(swiper);
                            }}
                            loop={true}
                            autoplay={{ delay: 1500, disableOnInteraction: false }}
                            modules={[Autoplay]}
                            breakpoints={{
                                0: { slidesPerView: 1 },
                                500: { slidesPerView: 2 },
                                576: { slidesPerView: 3 },
                                768: { slidesPerView: 4 },
                                1024: { slidesPerView: 4 },
                                1280: { slidesPerView: 6 },
                            }}
                        >
                            {allPartners.map((slide, idx) => {
                                const isActive = activeIndexes.includes(idx);
                                return (
                                    <SwiperSlide
                                        key={`service-${idx}-${slide.id}`}
                                        className={isActive ? "active-slide" : "slide"}
                                        data-swiper-slide-index={idx}
                                    >
                                        <img src={slide.logo} alt={slide.name} />
                                    </SwiperSlide>
                                );
                            })}
                        </Swiper>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default HomeSLider;
